"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SvgBrowsers = function SvgBrowsers(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    fill: "none",
    viewBox: "0 0 48 48",
    role: "img",
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M42.712 16.069a6.076 6.076 0 0 1-.69.306c-.748.278-1.54.42-2.337.417-3.08 0-5.762-2.116-5.762-4.838a2.05 2.05 0 0 1 1.068-1.777c-2.787.117-3.503 3.02-3.503 4.72 0 4.818 4.434 5.3 5.39 5.3.515 0 1.29-.15 1.759-.3l.084-.026a8.353 8.353 0 0 0 4.336-3.438.26.26 0 0 0-.345-.364Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M42.712 16.069a6.076 6.076 0 0 1-.69.306c-.748.278-1.54.42-2.337.417-3.08 0-5.762-2.116-5.762-4.838a2.05 2.05 0 0 1 1.068-1.777c-2.787.117-3.503 3.02-3.503 4.72 0 4.818 4.434 5.3 5.39 5.3.515 0 1.29-.15 1.759-.3l.084-.026a8.353 8.353 0 0 0 4.336-3.438.26.26 0 0 0-.345-.364Z",
    opacity: ".35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M34.548 19.376a5.156 5.156 0 0 1-1.478-1.387 5.254 5.254 0 0 1 1.92-7.812c.21-.098.554-.267 1.017-.26a2.11 2.11 0 0 1 1.673.846c.262.352.405.778.41 1.217 0-.013 1.595-5.182-5.209-5.182-2.858 0-5.208 2.708-5.208 5.091a8.475 8.475 0 0 0 .788 3.646 8.333 8.333 0 0 0 10.182 4.362 4.915 4.915 0 0 1-4.088-.52h-.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M34.548 19.376a5.156 5.156 0 0 1-1.478-1.387 5.254 5.254 0 0 1 1.92-7.812c.21-.098.554-.267 1.017-.26a2.11 2.11 0 0 1 1.673.846c.262.352.405.778.41 1.217 0-.013 1.595-5.182-5.209-5.182-2.858 0-5.208 2.708-5.208 5.091a8.475 8.475 0 0 0 .788 3.646 8.333 8.333 0 0 0 10.182 4.362 4.915 4.915 0 0 1-4.088-.52h-.007Z",
    opacity: ".41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M37.588 13.354c-.058.065-.221.163-.221.365 0 .17.11.338.313.475.93.651 2.695.56 2.701.56a3.88 3.88 0 0 0 1.973-.54 3.997 3.997 0 0 0 1.98-3.444c.019-1.459-.522-2.429-.737-2.858C42.211 5.216 39.236 3.667 36 3.667a8.333 8.333 0 0 0-8.334 8.216c.033-2.376 2.396-4.297 5.209-4.297.228 0 1.53.02 2.734.651a4.726 4.726 0 0 1 2.012 1.908c.397.69.469 1.569.469 1.92 0 .352-.176.866-.508 1.296l.006-.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M37.588 13.354c-.058.065-.221.163-.221.365 0 .17.11.338.313.475.93.651 2.695.56 2.701.56a3.88 3.88 0 0 0 1.973-.54 3.997 3.997 0 0 0 1.98-3.444c.019-1.459-.522-2.429-.737-2.858C42.211 5.216 39.236 3.667 36 3.667a8.333 8.333 0 0 0-8.334 8.216c.033-2.376 2.396-4.297 5.209-4.297.228 0 1.53.02 2.734.651a4.726 4.726 0 0 1 2.012 1.908c.397.69.469 1.569.469 1.92 0 .352-.176.866-.508 1.296l.006-.007Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "36",
    r: "8.667",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.001",
    cy: "36.001",
    r: "7.944",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    fillRule: "evenodd",
    d: "M12.08 28.534a.083.083 0 0 0-.083.083v1.268a.083.083 0 0 0 .167 0v-1.268a.083.083 0 0 0-.083-.083Zm0 15.093a.083.083 0 0 0 .084-.084v-1.268a.083.083 0 0 0-.167 0v1.268c0 .046.037.084.084.084Zm.65-14.982a.083.083 0 0 1 .166.017l-.054.54a.083.083 0 1 1-.166-.016l.054-.541ZM11.34 43.59a.083.083 0 0 0 .092-.074l.054-.541a.083.083 0 0 0-.166-.017l-.054.54a.083.083 0 0 0 .075.092Zm8.203-7.593a.083.083 0 1 1 0 .167h-1.267a.083.083 0 1 1 0-.167h1.267Zm-15.009.083c0 .046.037.084.084.084h1.267a.083.083 0 0 0 0-.167H4.618a.083.083 0 0 0-.084.083Zm14.982.65a.083.083 0 0 1-.017.166l-.54-.055a.083.083 0 0 1 .016-.165l.54.054ZM4.57 35.34a.083.083 0 0 0 .074.092l.54.054a.083.083 0 0 0 .018-.166l-.541-.054a.083.083 0 0 0-.091.074Zm12.728-4.596a.083.083 0 0 1 .117.118l-.896.897a.083.083 0 0 1-.118-.118l.897-.897ZM6.744 41.416a.083.083 0 0 0 .118 0l.897-.896a.083.083 0 0 0-.118-.118l-.897.896a.083.083 0 0 0 0 .118Zm11.053-10.135a.083.083 0 1 1 .105.13l-.42.344a.083.083 0 1 1-.105-.129l.42-.345Zm-11.55 9.587c.03.035.082.04.117.011l.42-.345a.083.083 0 0 0-.105-.128l-.42.344a.083.083 0 0 0-.012.118Zm11.17.43a.083.083 0 1 1-.118.118l-.897-.896a.083.083 0 1 1 .118-.118l.896.896ZM6.743 30.744a.083.083 0 0 0 0 .118l.897.897a.083.083 0 0 0 .118-.118l-.897-.897a.083.083 0 0 0-.118 0ZM16.88 41.796a.083.083 0 1 1-.129.106l-.344-.42a.083.083 0 1 1 .129-.106l.344.42Zm-9.586-11.55a.083.083 0 0 0-.011.118l.344.42a.083.083 0 1 0 .13-.105l-.346-.42a.083.083 0 0 0-.117-.012Zm7.566-1.092a.083.083 0 1 1 .154.063l-.485 1.172a.083.083 0 0 1-.154-.064l.485-1.171ZM9.193 43.052a.083.083 0 0 0 .109-.045l.485-1.171a.083.083 0 1 0-.154-.064l-.485 1.171a.083.083 0 0 0 .045.11Zm6.332-13.593a.083.083 0 1 1 .147.079l-.256.479a.083.083 0 0 1-.147-.078l.256-.48ZM8.523 42.736c.04.021.091.006.113-.035l.256-.479a.083.083 0 0 0-.147-.079l-.256.48a.083.083 0 0 0 .034.113Zm10.484-3.877a.083.083 0 0 1-.064.154l-1.171-.485a.083.083 0 1 1 .064-.154l1.171.485ZM5.11 33.192a.083.083 0 0 0 .045.11l1.171.484a.083.083 0 0 0 .064-.154l-1.172-.485a.083.083 0 0 0-.108.045ZM18.7 39.525a.083.083 0 1 1-.078.147l-.48-.256a.083.083 0 1 1 .08-.147l.479.256ZM5.425 32.523a.083.083 0 0 0 .034.113l.48.256a.083.083 0 1 0 .078-.147l-.479-.256a.083.083 0 0 0-.113.034Zm13.518.624a.083.083 0 0 1 .064.154l-1.171.485a.083.083 0 0 1-.064-.154l1.172-.485ZM5.11 38.968a.083.083 0 0 0 .108.045l1.172-.485a.083.083 0 1 0-.064-.154l-1.171.485a.083.083 0 0 0-.045.11Zm14.089-5.134a.083.083 0 1 1 .048.16l-.52.157a.083.083 0 1 1-.048-.16l.52-.157ZM4.859 38.271c.013.044.06.069.104.055l.52-.157a.083.083 0 1 0-.048-.16l-.52.158a.083.083 0 0 0-.056.104Zm10.11 4.781a.083.083 0 0 1-.11-.045l-.485-1.171a.083.083 0 1 1 .154-.064l.485 1.171a.083.083 0 0 1-.045.11ZM9.192 29.108a.083.083 0 0 0-.045.11l.485 1.17a.083.083 0 0 0 .154-.063l-.485-1.171a.083.083 0 0 0-.11-.046Zm5.134 14.09a.083.083 0 1 1-.16.048l-.158-.52a.083.083 0 1 1 .16-.048l.158.52ZM9.89 28.858a.083.083 0 0 0-.056.105l.158.52a.083.083 0 1 0 .16-.049l-.158-.52a.083.083 0 0 0-.104-.055Zm3.565-.114a.083.083 0 0 1 .163.033l-.247 1.244a.083.083 0 0 1-.164-.033l.248-1.244Zm-2.847 14.737a.083.083 0 0 0 .098-.065l.248-1.244a.083.083 0 1 0-.164-.032l-.247 1.243c-.01.046.02.09.065.098Zm3.56-14.567a.083.083 0 0 1 .159.049l-.158.52a.083.083 0 1 1-.16-.049l.158-.52ZM9.89 43.302a.083.083 0 0 0 .104-.056l.158-.52a.083.083 0 0 0-.16-.048l-.158.52a.083.083 0 0 0 .056.104Zm9.526-5.848a.083.083 0 0 1-.032.164l-1.244-.248a.083.083 0 1 1 .033-.163l1.243.247ZM4.68 34.608a.083.083 0 0 0 .066.098l1.243.247a.083.083 0 0 0 .033-.163l-1.244-.247a.083.083 0 0 0-.098.065Zm14.567 3.559a.083.083 0 1 1-.048.16l-.52-.158a.083.083 0 1 1 .048-.16l.52.158ZM4.86 33.89a.083.083 0 0 0 .056.104l.52.157a.083.083 0 1 0 .048-.16l-.52-.157a.083.083 0 0 0-.104.056Zm13.38-2.025a.083.083 0 0 1 .093.138l-1.054.705a.083.083 0 0 1-.093-.139l1.054-.704ZM5.806 40.273a.083.083 0 0 0 .116.023l1.054-.705a.083.083 0 0 0-.093-.138l-1.054.704a.083.083 0 0 0-.023.116Zm12.817-7.784a.083.083 0 1 1 .078.147l-.479.256a.083.083 0 1 1-.078-.147l.479-.256ZM5.425 39.638c.022.04.072.055.113.034l.48-.256a.083.083 0 0 0-.08-.147l-.479.256a.083.083 0 0 0-.034.113Zm10.871 2.601a.083.083 0 0 1-.139.093l-.704-1.054a.083.083 0 0 1 .139-.093l.704 1.054ZM7.888 29.806a.083.083 0 0 0-.023.115l.704 1.055a.083.083 0 1 0 .139-.093l-.704-1.054a.083.083 0 0 0-.116-.023Zm7.784 12.817a.083.083 0 1 1-.147.078l-.256-.479a.083.083 0 1 1 .147-.079l.256.48ZM8.523 29.425a.083.083 0 0 0-.034.113l.256.479a.083.083 0 0 0 .147-.078l-.256-.48a.083.083 0 0 0-.113-.034Zm7.634.404a.083.083 0 0 1 .139.092l-.704 1.055a.083.083 0 1 1-.14-.093l.705-1.054ZM7.888 42.355c.038.025.09.015.116-.023l.704-1.054a.083.083 0 1 0-.139-.093l-.704 1.054a.083.083 0 0 0 .023.116Zm8.862-12.097a.083.083 0 1 1 .13.106l-.345.42a.083.083 0 1 1-.13-.105l.345-.42ZM7.293 41.914c.036.029.088.024.117-.012l.345-.42a.083.083 0 0 0-.129-.106l-.344.42a.083.083 0 0 0 .011.118Zm11.039-1.757a.083.083 0 1 1-.093.139l-1.054-.705a.083.083 0 1 1 .093-.138l1.054.704Zm-12.526-8.27a.083.083 0 0 0 .023.116l1.054.705a.083.083 0 0 0 .093-.139l-1.054-.704a.083.083 0 0 0-.116.023Zm12.096 8.863a.083.083 0 0 1-.105.13l-.42-.346a.083.083 0 1 1 .105-.128l.42.344ZM6.247 31.293a.083.083 0 0 0 .012.117l.42.345a.083.083 0 1 0 .105-.129l-.42-.345a.083.083 0 0 0-.117.012Zm13.137 3.25a.083.083 0 1 1 .032.163l-1.243.247a.083.083 0 0 1-.033-.163l1.244-.247Zm-14.705 3.01a.083.083 0 0 0 .098.065l1.244-.248a.083.083 0 1 0-.033-.163l-1.243.247a.083.083 0 0 0-.066.098Zm14.82-2.287a.083.083 0 1 1 .017.166l-.541.054a.083.083 0 1 1-.017-.166l.541-.054ZM4.571 36.82c.004.046.045.08.09.075l.542-.055a.083.083 0 0 0-.017-.165l-.54.054a.083.083 0 0 0-.075.091Zm9.047 6.563a.083.083 0 0 1-.163.032l-.248-1.244a.083.083 0 0 1 .164-.032l.247 1.243Zm-3.01-14.705a.083.083 0 0 0-.065.098l.247 1.244a.083.083 0 1 0 .164-.033l-.248-1.244a.083.083 0 0 0-.098-.065Zm2.288 14.82a.083.083 0 0 1-.166.017l-.054-.541a.083.083 0 0 1 .166-.017l.054.54ZM11.341 28.57a.083.083 0 0 0-.075.091l.054.541a.083.083 0 0 0 .166-.016l-.054-.541a.083.083 0 0 0-.091-.075Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "m6.543 41.457 4.664-6.26.793.794-5.457 5.466Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E44",
    d: "m11.198 35.208 6.259-4.665L11.991 36l-.793-.792Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    d: "m17.457 30.543-4.665 6.26-.792-.794 5.457-5.466Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    d: "m6.543 41.457 6.26-4.665-.794-.792-5.466 5.457Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M44.265 32.373c-.388-.932-1.173-1.939-1.79-2.257.502.984.793 1.97.904 2.707l.002.015c-1.009-2.514-2.719-3.527-4.115-5.734-.07-.112-.141-.224-.21-.342a2.736 2.736 0 0 1-.098-.184 1.618 1.618 0 0 1-.14-.369.024.024 0 0 0-.014-.008.032.032 0 0 0-.017 0l-.004.002-.007.004.004-.005c-2.24 1.312-3 3.74-3.07 4.954a4.462 4.462 0 0 0-2.455.946 2.643 2.643 0 0 0-.23-.175 4.131 4.131 0 0 1-.026-2.18c-.916.418-1.629 1.077-2.147 1.66h-.004c-.353-.448-.328-1.926-.308-2.234-.004-.02-.264.135-.298.158a6.502 6.502 0 0 0-.871.747 7.82 7.82 0 0 0-.834 1v-.002a7.525 7.525 0 0 0-1.196 2.702l-.012.059c-.017.078-.077.471-.088.556 0 .007 0 .013-.002.02a8.495 8.495 0 0 0-.144 1.23l-.001.046a8.92 8.92 0 0 0 17.709 1.509c.015-.114.027-.229.04-.344.177-1.53-.02-3.137-.578-4.48Zm-10.28 6.98c.042.02.082.042.124.061l.006.004a4.474 4.474 0 0 1-.13-.065Zm9.396-6.513-.001-.009.002.01v-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M44.265 32.373c-.388-.932-1.173-1.939-1.79-2.257.502.984.793 1.97.904 2.707l.001.008.002.01c.841 2.28.383 4.6-.278 6.018-1.022 2.193-3.496 4.44-7.37 4.331-4.183-.118-7.87-3.223-8.558-7.29-.125-.64 0-.966.063-1.487-.076.402-.106.518-.144 1.23l-.001.046a8.92 8.92 0 0 0 17.709 1.509c.015-.114.027-.229.04-.344.177-1.53-.02-3.137-.578-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M44.265 32.373c-.388-.932-1.173-1.939-1.79-2.257.502.984.793 1.97.904 2.707l.001.008.002.01c.841 2.28.383 4.6-.278 6.018-1.022 2.193-3.496 4.44-7.37 4.331-4.183-.118-7.87-3.223-8.558-7.29-.125-.64 0-.966.063-1.487-.076.402-.106.518-.144 1.23l-.001.046a8.92 8.92 0 0 0 17.709 1.509c.015-.114.027-.229.04-.344.177-1.53-.02-3.137-.578-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M39.93 33.422c.02.013.038.027.056.04a4.85 4.85 0 0 0-.828-1.08c-2.772-2.772-.727-6.01-.382-6.175l.004-.005c-2.24 1.312-3 3.74-3.07 4.954.104-.008.207-.016.313-.016a4.5 4.5 0 0 1 3.908 2.282Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M36.028 33.975c-.014.222-.798.987-1.072.987-2.536 0-2.948 1.534-2.948 1.534.113 1.291 1.012 2.355 2.101 2.918a4.873 4.873 0 0 0 .412.179c.374.132.765.208 1.16.224 4.446.208 5.307-5.314 2.1-6.918.82-.143 1.673.188 2.15.522a4.5 4.5 0 0 0-3.908-2.281c-.106 0-.21.008-.313.016a4.463 4.463 0 0 0-2.455.945c.136.116.29.27.613.588.605.596 2.157 1.213 2.16 1.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M36.028 33.975c-.014.222-.798.987-1.072.987-2.536 0-2.948 1.534-2.948 1.534.113 1.291 1.012 2.355 2.101 2.918a4.873 4.873 0 0 0 .412.179c.374.132.765.208 1.16.224 4.446.208 5.307-5.314 2.1-6.918.82-.143 1.673.188 2.15.522a4.5 4.5 0 0 0-3.908-2.281c-.106 0-.21.008-.313.016a4.463 4.463 0 0 0-2.455.945c.136.116.29.27.613.588.605.596 2.157 1.213 2.16 1.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M32.84 31.805c.062.04.123.08.184.122a4.132 4.132 0 0 1-.025-2.18c-.916.418-1.628 1.077-2.147 1.66.043-.002 1.337-.025 1.988.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M27.176 35.9c.688 4.067 4.374 7.172 8.559 7.29 3.873.11 6.347-2.138 7.369-4.331.66-1.418 1.119-3.737.277-6.018v-.001l-.001-.009-.002-.008.002.015c.316 2.065-.734 4.066-2.377 5.42l-.005.01c-3.2 2.607-6.263 1.573-6.883 1.15a5.233 5.233 0 0 1-.13-.065c-1.866-.892-2.636-2.591-2.471-4.05-1.576 0-2.113-1.328-2.113-1.328s1.415-1.009 3.279-.132c1.727.813 3.348.132 3.348.132-.003-.073-1.555-.69-2.16-1.286-.324-.319-.477-.472-.613-.588a2.662 2.662 0 0 0-.231-.174 10.374 10.374 0 0 0-.185-.122c-.65-.423-1.944-.4-1.987-.399h-.004c-.354-.448-.328-1.925-.308-2.233-.005-.02-.264.135-.298.158a6.495 6.495 0 0 0-.872.746c-.305.31-.583.644-.832 1a7.525 7.525 0 0 0-1.197 2.701c-.004.02-.321 1.404-.165 2.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M39.158 32.382c.325.32.604.683.828 1.08.049.037.095.074.134.11 2.022 1.863.962 4.497.883 4.685 1.643-1.353 2.694-3.354 2.377-5.42-1.008-2.513-2.718-3.527-4.115-5.733-.07-.112-.14-.224-.21-.342a2.692 2.692 0 0 1-.098-.184 1.624 1.624 0 0 1-.139-.369.023.023 0 0 0-.014-.008.032.032 0 0 0-.017 0l-.005.002-.006.004c-.345.165-2.39 3.403.382 6.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M40.12 33.572a1.754 1.754 0 0 0-.134-.11l-.055-.04c-.476-.335-1.33-.665-2.15-.523 3.207 1.604 2.346 7.126-2.099 6.918a3.963 3.963 0 0 1-1.16-.224 4.957 4.957 0 0 1-.413-.179l.006.004c.62.423 3.683 1.457 6.884-1.15l.005-.01c.079-.188 1.138-2.823-.884-4.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M32.009 36.496s.411-1.534 2.947-1.534c.274 0 1.058-.765 1.073-.987.014-.222-1.622.681-3.349-.131-1.864-.878-3.279.131-3.279.131s.538 1.329 2.113 1.329c-.165 1.458.606 3.158 2.472 4.05.041.02.08.041.123.06-1.089-.563-1.988-1.627-2.1-2.918Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M44.265 32.373c-.388-.932-1.173-1.939-1.79-2.257.502.984.793 1.97.904 2.707l.001.015c-1.008-2.514-2.718-3.527-4.114-5.734-.07-.112-.142-.224-.21-.342a2.735 2.735 0 0 1-.099-.184 1.618 1.618 0 0 1-.139-.369.023.023 0 0 0-.014-.008.032.032 0 0 0-.017 0l-.004.002-.007.004.004-.005c-2.24 1.312-3 3.74-3.07 4.954.103-.008.207-.016.313-.016a4.5 4.5 0 0 1 3.907 2.281c-.476-.334-1.328-.664-2.15-.522 3.208 1.604 2.347 7.126-2.098 6.918a3.964 3.964 0 0 1-1.16-.224 4.957 4.957 0 0 1-.413-.179l.006.004a5.406 5.406 0 0 1-.13-.065c.042.02.081.042.124.061-1.09-.563-1.989-1.627-2.1-2.918 0 0 .41-1.534 2.947-1.534.274 0 1.058-.765 1.072-.987-.003-.073-1.555-.69-2.16-1.286-.324-.319-.477-.472-.613-.588a2.662 2.662 0 0 0-.231-.174 4.131 4.131 0 0 1-.025-2.18c-.916.418-1.629 1.077-2.147 1.66h-.004c-.354-.448-.329-1.926-.308-2.234-.005-.02-.264.135-.298.158a6.496 6.496 0 0 0-.872.747c-.305.309-.583.643-.832.998v.002-.002a7.527 7.527 0 0 0-1.197 2.702l-.012.059c-.017.078-.092.477-.103.562 0 .007.001-.006 0 0a10.37 10.37 0 0 0-.131 1.245l-.001.045a8.92 8.92 0 0 0 17.709 1.509c.015-.114.027-.229.04-.344.177-1.53-.02-3.137-.578-4.48Zm-.885.458.001.01v-.001l-.001-.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4437",
    d: "m8.704 13.896 3.29-5.677 7.407-.017A8.333 8.333 0 0 0 5.004 7.46l3.7 6.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    d: "m15.293 13.895-6.561-.011-3.718-6.406a8.333 8.333 0 0 0 6.555 12.84l3.724-6.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD40",
    d: "m11.985 8.188 3.281 5.682-3.676 6.43a8.333 8.333 0 0 0 7.82-12.112h-7.425Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M12.015 8.216V10.2l7.424-1.984h-7.424Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "m5.005 7.501 5.421 5.42-1.691.977-3.73-6.397Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "m11.62 20.327 1.985-7.405 1.691.976-3.676 6.429Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.015",
    cy: "12.004",
    r: "3.788",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.015",
    cy: "12.004",
    r: "3.03",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.21094 0 0 5.90039 37.901 15.278)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".7",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".9",
    stopOpacity: ".5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(1.39843 -9.22969 7.45666 1.12979 32.26 16.618)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".8",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".9",
    stopOpacity: ".5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(-.52708 13.17706 -28.06446 -1.12257 29.352 6.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".1",
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".2",
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".3",
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".7",
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "rotate(73.74 15.848 33.213) scale(6.33463 5.15133)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#66EB6E",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "translate(12.002 36.005) scale(7.94444)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#0070E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(18.2401 0 0 18.5472 39.436 28.252)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".13",
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".28",
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".47",
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".78",
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".86",
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(18.6961 0 0 18.5472 34.147 35.912)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".3",
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".35",
    stopColor: "#B11927",
    stopOpacity: ".74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".43",
    stopColor: "#DB293D",
    stopOpacity: ".34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".5",
    stopColor: "#F5334B",
    stopOpacity: ".09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".53",
    stopColor: "#FF3750",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(5.98687 0 0 10.1642 37.763 25.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".13",
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".53",
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(7.92222 0 0 8.68285 33.811 40.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".35",
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".67",
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(4.2067 0 0 5.12288 35.165 34.005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".21",
    stopColor: "#9059FF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".97",
    stopColor: "#6E008B",
    stopOpacity: ".6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.29819 0 0 6.32057 35.413 27.568)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".1",
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".79",
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(30.0689 0 0 25.2412 41.165 23.422)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".11",
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".46",
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".72",
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".9",
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(2.08193 9.30988 -40.27319 9.0061 29.998 31.757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".3",
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".57",
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".74",
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(17.264 0 0 16.9607 35.478 29.842)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".14",
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".48",
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".66",
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".9",
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(20.7507 0 0 18.564 39.959 30.834)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".09",
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".63",
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(7.96186 0 0 2.12756 11.654 8.211)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: ".2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3E2723",
    stopOpacity: ".01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(7.39055 0 0 8.72018 4.996 7.508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: ".2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3E2723",
    stopOpacity: ".01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(8.321 0 0 16.762 12 12.017)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: ".2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#263238",
    stopOpacity: ".01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "31.488",
    x2: "43.103",
    y1: "15.19",
    y2: "15.19",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "37.608",
    x2: "30.362",
    y1: "10.151",
    y2: "18.048",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".2",
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".7",
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "3.338",
    x2: "3.338",
    y1: "27.338",
    y2: "44.672",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#CCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "42.635",
    x2: "28.315",
    y1: "29.053",
    y2: "42.867",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".05",
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".37",
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".53",
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".7",
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "41.344",
    x2: "29.893",
    y1: "28.777",
    y2: "41.288",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".17",
    stopColor: "#FFF44F",
    stopOpacity: ".8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".6",
    stopColor: "#FFF44F",
    stopOpacity: "0"
  }))));
};

var _default = SvgBrowsers;
exports["default"] = _default;